import user from "./user";
import notification from "./notification";
import order from "./order";
import depositRequest from "./deposit-request";
import debt from "./debt";
export default [...user, ...notification, ...order, ...depositRequest, ...debt];
